import { t } from "@/i18n-js/instance";
import { BlockInViewOnlyMode } from "@circle-react/components/ViewOnlyMasquerading/BlockInViewOnlyMode";
import { Icon } from "@circle-react/components/shared/Icon";

interface FloatingActionButtonProps {
  isOpen: boolean;
  onClick: () => void;
}

const buttonStyle = {
  background: "linear-gradient(180deg, #506CF1 0%, #0F26A6 100%)",
};

export const FloatingActionButton = ({
  isOpen,
  onClick,
}: FloatingActionButtonProps) => (
  <BlockInViewOnlyMode>
    <button
      type="submit"
      className="bg-support-widget float-right hidden h-14 w-14 items-center justify-center self-end rounded-full text-white shadow-md lg:flex"
      style={buttonStyle}
      onClick={onClick}
      aria-label={t("support_widget.floating_button_aria_label")}
      aria-expanded={isOpen}
      aria-controls="support-widget"
    >
      <Icon
        type="support-widget-v2-fab"
        style={{ width: 32, height: 32, paddingTop: 5 }}
      />
    </button>
  </BlockInViewOnlyMode>
);
